export default [
  {
    path: "/",
    redirect: "/home"
  },
  {
    name: "home",
    path: "/home",
    meta: {
      title: "目录"
    },
    component: () => import(/* webpackChunkName: "commonModule" */ "@/views/home.vue")
  }
]